export const SELLER_NAME = "ChatGPT во VK";
export const SELLER_STATUS = "Самозанятый сервис";
export const SELLER_INN = "226702366647";
export const SUPPORT_EMAIL = "easybej1ukuu@gmail.com";
export const TELEGRAM_SUPPORT_HANDLE = "@qwizyop";
export const TELEGRAM_SUPPORT_URL = "https://t.me/qwizyop";
export const VK_COMMUNITY_URL = "https://vk.com/newchatgpt";
export const VK_MESSAGES_URL = "https://vk.com/write-214449286";
export const VK_OFFER_URL = "https://sverhum.ru/policy.html";

export const capabilityCards = [
  {
    title: "Ответы текстом и голосом",
    description: "Помощь с учёбой, рабочими задачами, идеями, анализом и объяснениями простым языком."
  },
  {
    title: "Решение задач по фото",
    description: "Распознавание условия, пошаговое решение и разбор ошибок без ручного переписывания текста."
  },
  {
    title: "Изображения, фотосеты и музыка",
    description: "Генерация визуала и песен внутри одного сервиса, без поиска отдельных инструментов."
  },
  {
    title: "Работа без лишних барьеров",
    description: "Доступ через VK, понятные тарифы, поддержка и оплата через YooKassa в несколько шагов."
  }
];

export const useCaseCards = [
  {
    title: "Учёба",
    description: "Решение задач, объяснение тем, помощь с сочинениями, конспектами и проверкой текста."
  },
  {
    title: "Контент",
    description: "Идеи для постов, изображения, фотосеты, тексты для соцсетей и быстрые черновики."
  },
  {
    title: "Повседневные задачи",
    description: "Письма, планы, резюме, структурирование мыслей и ответы на бытовые вопросы."
  }
];

export const planCards = [
  {
    id: 1,
    title: "Lite",
    price: 379,
    badge: "Для учёбы и ежедневных задач",
    description: "Базовый ежемесячный тариф для тех, кому нужен быстрый ИИ-помощник без очереди.",
    features: [
      "30 000 токенов в месяц",
      "Текстовые и голосовые ответы",
      "Распознавание задач по фото",
      "Генерация изображений и ИИ-фотосессии"
    ]
  },
  {
    id: 2,
    title: "Pro",
    price: 599,
    badge: "Оптимальный тариф",
    description: "Подходит для контента, визуала и более активной ежедневной работы с сервисом.",
    features: [
      "70 000 токенов в месяц",
      "Всё из Lite",
      "Генерация песен",
      "Приоритетная обработка запросов"
    ]
  },
  {
    id: 3,
    title: "Max",
    price: 1190,
    badge: "Максимум возможностей",
    description: "Для тех, кому нужен расширенный лимит, доступ к видео и поддержка в приоритетном порядке.",
    features: [
      "140 000 токенов в месяц",
      "Всё из Pro",
      "Генерация видео",
      "Максимальный приоритет и ранний доступ к новому"
    ]
  }
];

export const oneTimeCards = [
  {
    id: 9,
    title: "ИИ-фотосессия",
    price: 29,
    description: "Разовая генерация фотосета по вашему фото."
  },
  {
    id: 10,
    title: "Пакет фотосессий",
    price: 96,
    description: "6 генераций в формате ежемесячного пакета."
  },
  {
    id: 11,
    title: "Решение задачи по фото",
    price: 19,
    description: "После оплаты на баланс начисляется 3000 токенов."
  },
  {
    id: 12,
    title: "Пакет решений по фото",
    price: 79,
    description: "10 решений по фото в формате ежемесячного пакета."
  },
  {
    id: 13,
    title: "Генерация песни",
    price: 29,
    description: "Разовая покупка одной музыкальной генерации."
  },
  {
    id: 14,
    title: "Пакет песен",
    price: 96,
    description: "6 музыкальных генераций в формате ежемесячного пакета."
  }
];

export const processSteps = [
  {
    title: "1. Вы выбираете тариф или услугу",
    description: "Выбираете подходящий тариф или разовую услугу под нужный сценарий использования."
  },
  {
    title: "2. Открывается страница оплаты",
    description: "На странице отображаются данные заказа, сумма и доступные способы оплаты."
  },
  {
    title: "3. Оплата проходит через YooKassa",
    description: "На странице видно, что именно оплачивается, сколько стоит покупка и как получить доступ после оплаты."
  },
  {
    title: "4. Доступ начисляется автоматически",
    description: "После успешной оплаты сервис активирует подписку или начисляет разовые генерации и пакеты."
  }
];

export const faqItems = [
  {
    question: "Как я получу доступ после оплаты?",
    answer: "Подписка или разовая услуга активируется автоматически по сценарию, выбранному для этой покупки."
  },
  {
    question: "Что отображается на странице оплаты?",
    answer: "На странице оплаты отображаются состав заказа, итоговая сумма, доступные способы оплаты и информация о начислении доступа."
  },
  {
    question: "Какие способы оплаты доступны?",
    answer: "Оплата проводится через YooKassa. В зависимости от сценария доступны общий сценарий YooKassa, карта и СБП."
  },
  {
    question: "Где посмотреть условия использования?",
    answer: "Политика и условия использования доступны по ссылке на сайте. Контакты для связи также указаны на сайте."
  }
];

const productPresentation = {
  1: {
    title: "Lite",
    summary: "Ежемесячная подписка с базовым набором ИИ-возможностей.",
    typeLabel: "Ежемесячная подписка",
    delivery: "После оплаты тариф Lite активируется автоматически на 30 дней.",
    features: [
      "30 000 токенов",
      "Текст и голос",
      "Фото-задачи",
      "Изображения и фотосеты"
    ]
  },
  2: {
    title: "Pro",
    summary: "Основной тариф для активного использования сервиса и контент-задач.",
    typeLabel: "Ежемесячная подписка",
    delivery: "После оплаты тариф Pro активируется автоматически на 30 дней.",
    features: [
      "70 000 токенов",
      "Всё из Lite",
      "Музыкальные генерации",
      "Приоритетная очередь"
    ]
  },
  3: {
    title: "Max",
    summary: "Расширенный тариф с максимальным лимитом и дополнительными возможностями.",
    typeLabel: "Ежемесячная подписка",
    delivery: "После оплаты тариф Max активируется автоматически на 30 дней.",
    features: [
      "140 000 токенов",
      "Всё из Pro",
      "Видео",
      "Максимальный приоритет"
    ]
  },
  4: {
    title: "Пакет 10 000 токенов",
    summary: "Разовая покупка дополнительного токен-баланса.",
    typeLabel: "Разовая покупка",
    delivery: "После оплаты 10 000 токенов будут начислены автоматически.",
    features: ["10 000 токенов", "Без подписки", "Начисление автоматически", "Для текущего аккаунта"]
  },
  5: {
    title: "Пакет 20 000 токенов",
    summary: "Разовая покупка увеличенного токен-баланса.",
    typeLabel: "Разовая покупка",
    delivery: "После оплаты 20 000 токенов будут начислены автоматически.",
    features: ["20 000 токенов", "Без подписки", "Начисление автоматически", "Для текущего аккаунта"]
  },
  6: {
    title: "Пакет 30 000 токенов",
    summary: "Разовая покупка большого токен-баланса для интенсивного использования.",
    typeLabel: "Разовая покупка",
    delivery: "После оплаты 30 000 токенов будут начислены автоматически.",
    features: ["30 000 токенов", "Без подписки", "Начисление автоматически", "Для текущего аккаунта"]
  },
  7: {
    title: "1 билет рулетки",
    summary: "Разовая покупка одного платного вращения.",
    typeLabel: "Разовая покупка",
    delivery: "После оплаты 1 билет появится в разделе рулетки автоматически.",
    features: ["1 билет", "Начисление автоматически", "Использование в сервисе", "Без ручной активации"]
  },
  8: {
    title: "3 билета рулетки",
    summary: "Разовая покупка пакета платных вращений.",
    typeLabel: "Разовая покупка",
    delivery: "После оплаты 3 билета появятся в разделе рулетки автоматически.",
    features: ["3 билета", "Начисление автоматически", "Использование в сервисе", "Без ручной активации"]
  },
  9: {
    title: "ИИ-фотосессия: 1 генерация",
    summary: "Разовая генерация фотосета по вашему фото.",
    typeLabel: "Разовая покупка",
    delivery: "После оплаты 1 генерация появится в разделе «ИИ фотосессия».",
    features: ["1 генерация", "Для вашего аккаунта", "Быстрое начисление", "Начисление автоматически"]
  },
  10: {
    title: "ИИ-фотосессия: пакет 6 генераций",
    summary: "Ежемесячный пакет для регулярных фотосессий.",
    typeLabel: "Ежемесячный пакет",
    delivery: "После оплаты 6 генераций появятся в разделе «ИИ фотосессия».",
    features: ["6 генераций", "Для вашего аккаунта", "Быстрое начисление", "Пакетный формат"]
  },
  11: {
    title: "Решение задачи по фото: 3000 токенов",
    summary: "Разовая покупка: 3000 токенов на баланс для решений по фото.",
    typeLabel: "Разовая покупка",
    delivery: "После оплаты 3000 токенов будут начислены на баланс автоматически.",
    features: ["3000 токенов", "Распознавание и разбор", "Для вашего аккаунта", "Начисление автоматически"]
  },
  12: {
    title: "Пакет решений по фото: 10 доступов",
    summary: "Ежемесячный пакет для регулярной работы с фото-задачами.",
    typeLabel: "Ежемесячный пакет",
    delivery: "После оплаты 10 решений по фото будут начислены автоматически.",
    features: ["10 решений", "Для вашего аккаунта", "Начисление автоматически", "Пакетный формат"]
  },
  13: {
    title: "Генерация песни: 1 доступ",
    summary: "Разовая музыкальная генерация по вашему тексту.",
    typeLabel: "Разовая покупка",
    delivery: "После оплаты 1 музыкальная генерация будет начислена автоматически.",
    features: ["1 песня", "Для вашего аккаунта", "Быстрое начисление", "Начисление автоматически"]
  },
  14: {
    title: "Пакет песен: 6 генераций",
    summary: "Ежемесячный пакет музыкальных генераций.",
    typeLabel: "Ежемесячный пакет",
    delivery: "После оплаты 6 музыкальных генераций будут начислены автоматически.",
    features: ["6 песен", "Для вашего аккаунта", "Начисление автоматически", "Пакетный формат"]
  }
};

export function formatRub(value) {
  return new Intl.NumberFormat("ru-RU").format(Number(value || 0));
}

export function getProductPresentation(productId, fallbackTitle = "") {
  const item = productPresentation[Number(productId)] || null;
  if (item) return item;

  return {
    title: fallbackTitle || "Покупка в сервисе",
    summary: "Оплата цифровой услуги в сервисе ChatGPT во VK.",
    typeLabel: "Цифровая услуга",
    delivery: "После оплаты доступ будет начислен автоматически в рамках выбранного сценария покупки.",
    features: [
      "Цифровой формат",
      "Начисление автоматически",
      "Подтверждение после оплаты",
      "Оплата через YooKassa"
    ]
  };
}
